module.exports = __webpack_public_path__ + "img/ruanbao6.6e9eba06.jpg";